import styled, { css } from 'styled-components';
import { IconButton, TableRow } from '@mui/material';

export const Container = styled.div`
  &&& {
    .MuiTableCell-root {
      padding: 0.2rem 0.4rem;
      border-bottom: none;
      border-right: 1px solid ${({ theme }) => theme.grayDark};
    }
    .MuiTableCell-head {
      font-weight: bold;
    }
  }
`;
interface IPartTableRowProps {
  $isRecommended?: boolean;
  $isBlocked?: boolean;
}
export const PartTableRow = styled(TableRow)<IPartTableRowProps>`
  &&& {
    border: 1px solid
      ${({ theme, $isRecommended }) =>
        $isRecommended ? theme.pantone2726C : theme.grayDarker};
    transition: background 0.3s ease-out;
    &:hover {
      background: ${({ theme }) => theme.hoverGray};
    }
    ${({ theme, $isBlocked }) =>
      $isBlocked &&
      css`
        cursor: not-allowed;
        border: 1px solid ${theme.grayDarker};
        opacity: 0.8;
        filter: grayscale(0.6);

        .MuiButtonBase-root {
          cursor: not-allowed;
        }
      `};
    .MuiTableCell-body {
      &:last-child {
        border-right: none;
      }
    }
  }
`;

export const SupplierColumn = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  gap: 1rem;

  > span {
    width: 100%;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
export const PriceColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
`;

export const CartColumn = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const CartIconButton = styled(IconButton)`
  &&& {
    &:disabled {
      color: rgb(0 0 0 / 30%);
    }
  }
`;
export const AwaitingAnswer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.pantone2726C};
  font-weight: bold;
  font-size: 0.9rem;
  text-align: center;
`;
export const CustomColumn = styled.div`
  /* display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center; */
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  text-align: center;
  /* text-overflow: ellipsis; */
  /* white-space: nowrap; */
`;
interface IImagePartProps {
  $showCursor: boolean;
}
export const ImagePart = styled.img<IImagePartProps>`
  cursor: ${({ $showCursor }) => ($showCursor ? 'pointer' : 'default')};
  width: 100%;
  max-width: 100px;
  height: 80px;
  object-fit: contain;
`;

export const SkeletonPartTableRow = styled(PartTableRow)`
  &&& {
    .MuiTableCell-root {
      padding: 0.6rem 0.4rem;
    }
  }
`;

export const TextButtonOpen = styled.button`
  border: none;
  background: transparent;
  padding: 0;
  color: ${({ theme }) => theme.pantone2726C};
  padding: 0.5rem 0;
`;